import "core-js/modules/es6.function.name";
import _get from "lodash/get";
import bole from 'bole';
import datadog from '@nerdwallet/datadog';
var logger = bole('nwjs-analytics');
var LOG_LEVELS = {
  debug: 1,
  info: 2,
  warn: 3,
  error: 4,
  none: 5
};
/* eslint-disable no-console */

var createConsoleLogger = function createConsoleLogger(logLevel) {
  return {
    debug: function debug() {
      var _console;

      if (LOG_LEVELS[logLevel] > LOG_LEVELS.debug) return;

      (_console = console).debug.apply(_console, arguments);
    },
    info: function info() {
      var _console2;

      if (LOG_LEVELS[logLevel] > LOG_LEVELS.info) return;

      (_console2 = console).info.apply(_console2, arguments);
    },
    warn: function warn() {
      var _console3;

      if (LOG_LEVELS[logLevel] > LOG_LEVELS.warn) return;

      (_console3 = console).warn.apply(_console3, arguments);
    },
    error: function error() {
      var _console4;

      if (LOG_LEVELS[logLevel] > LOG_LEVELS.error) return;

      (_console4 = console).error.apply(_console4, arguments);
    }
  };
};
/* eslint-enable no-console */

/**
 * Logs an error in a structured format consumable by ELK. Also logs the error
 * in an a human-readable way if not running in production.
 */


export var defaultOnError = function defaultOnError(appConfig) {
  var logLevel = _get(appConfig, 'NWJS_ANALYTICS.LOG_LEVEL', 'error');

  var log = createConsoleLogger(logLevel);
  return function (err) {
    // log to stdout (for elk). this is a no-op on clients.
    logger.error({
      message: 'nwjs-analytics error',
      err: {
        name: err.name,
        message: err.message,
        code: err.code,
        stack: err.stack
      }
    });

    if (process.env.NODE_ENV === 'test') {
      // Throw when running tests so the test fails
      throw err;
    } // Log information for the developer


    log.error('An error occurred while sending analytics events:');

    if (err.stack) {
      log.error(err.stack);
    } else {
      log.error(err);
    } // keep track of error counts in datadog. this is a no-op on clients.


    datadog.increment('node.nwjs_analytics.errors', 1, {
      tags: {
        exception: err.code || err.name || err.message
      }
    });
  };
};
/**
 * Will be invoked every time transport occurs with an array of events and
 * the results of sending each one.
 */

export var defaultOnTransportResults = function defaultOnTransportResults(appConfig) {
  if (process.env.NODE_ENV === 'test') {
    // Don't log during tests to avoid spamming the console
    return function () {};
  }

  var logLevel = _get(appConfig, 'NWJS_ANALYTICS.LOG_LEVEL', 'error');

  var log = createConsoleLogger(logLevel);
  return function (_ref) {
    var events = _ref.events,
        results = _ref.results;
    results.forEach(function (result, index) {
      var originalEvent = events[index];
      var succeeded = result.success;
      if (succeeded && LOG_LEVELS[logLevel] > LOG_LEVELS.info) return;

      if (typeof document === 'undefined') {
        // We're running in a server context; don't use fancy console.log
        // formatting features.
        var message = "nwjs-analytics event ".concat(succeeded ? 'succeeded' : 'failed');
        logger.error({
          message: message,
          event: originalEvent,
          error: result.error
        });
        log.error(message);
        log.error('event', originalEvent);

        if (!succeeded) {
          log.error('error', result.error);
        }

        return;
      } // If we're running on the client, we can use formatting and
      // collapsible groups to make logs prettier. We only want to
      // show these logs when info level is turned on.


      if (LOG_LEVELS[logLevel] >= LOG_LEVELS.info) {
        var _console5;

        var parts = [];
        var formattingParts = [];
        parts.push("%cevent %c".concat(String(originalEvent.eventType)));
        formattingParts.push('color: gray; font-weight: lighter;', 'font-weight: bold;');

        var entityName = _get(originalEvent, 'payload.entity_name');

        if (entityName) {
          parts.push("%c".concat(entityName));
          formattingParts.push('font-weight: lighter; font-style: italic;');
        }

        if (succeeded) {
          parts.push('%csuccess');
          formattingParts.push('color: green');
        } else {
          parts.push('%cerror');
          formattingParts.push('color: red');
        }
        /* eslint-disable no-console */


        (_console5 = console).groupCollapsed.apply(_console5, [parts.join(' ')].concat(formattingParts));

        console.log('%cevent', 'font-weight: bold; color: #03A9F4;', originalEvent);

        if (!succeeded) {
          console.log('%cerror', 'font-weight: bold; color: red;', result.error);
        }

        console.groupEnd();
        /* eslint-enable no-console */
      }
    });
  };
};